import ServiceCategoryPage from '@/components/business/ServiceCategoryPage';
import { makeServiceCategoryPaths, makeServiceCategoryProps } from '@/lib/serviceCategoryFactory';
import { BusinessItem } from '@/core/models/businesses/businessList';
import { GetStaticPaths, GetStaticProps } from 'next';

const CATEGORY_ID = '549';
const CATEGORY_LABEL = 'Spares & Accessories';
const CATEGORY_SLUG = 'spares-accessories';
const CATEGORY_DESCRIPTION = 'Find vehicle spares and accessories suppliers near you. Browse parts, accessories, fitment centres and auto shops in your area.';
const TAGS: string[] = ['OEM Spares', 'Aftermarket Parts', 'Accessories', 'Fitment Centres'];

interface Props {
    businesses: BusinessItem[];
    pagination: { count: number; currentPage: number; totalPages: number };
    city: string;
    cityName: string;
}

export default function SparesAccessoriesCityPage({ businesses, pagination, city, cityName }: Props) {
    return (
        <ServiceCategoryPage
            businesses={businesses}
            pagination={pagination}
            city={city}
            cityName={cityName}
            categoryId={CATEGORY_ID}
            categoryLabel={CATEGORY_LABEL}
            categorySlug={CATEGORY_SLUG}
            categoryDescription={CATEGORY_DESCRIPTION}
            tags={TAGS}
        />
    );
}

export const getStaticPaths: GetStaticPaths = makeServiceCategoryPaths();
export const getStaticProps: GetStaticProps = makeServiceCategoryProps(CATEGORY_ID);
